import { render, staticRenderFns } from "./ManuallyChangeProjectConfig.vue?vue&type=template&id=17c60f28&"
import script from "./ManuallyChangeProjectConfig.vue?vue&type=script&lang=js&"
export * from "./ManuallyChangeProjectConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports